const validators = {
  user_name: {
    length: {
      minimum: 4,
      message: "^errors.login.invalid_email",
    },
  },
  password: {
    length: {
      minimum: 1,
      message: "^errors.login.password_required",
    },
  },
};
export default validators;
